module.exports = __webpack_public_path__ + "img/code_4A756C697573.28765aa8.svg";